import { createSelector } from 'reselect';

export const getSidebarShowDeck = state => state.layoutManager.showDeck;

export default createSelector([getSidebarShowDeck]);
